import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

export interface BlogListingBlock1Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  items?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const BlogListingBlock1 = forwardRef<
  HTMLDivElement,
  BlogListingBlock1Props
>(({ content, items, className, styles, ...rest }, ref) => {
  const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles({
    styles,
    defaultStyles: primaryBlockDefaultStyles,
  });

  return (
    <BlockSection ref={ref} className={className} {...rest}>
      <BlockSection.Background style={backgroundStyles}>
        <BlockSection.Container>
          <BlockSection.Content
            style={{
              ...paddingStyles,
              ...marginStyles,
            }}
          >
            <div className="wb-flex wb-flex-col wb-gap-12 md:wb-gap-20 wb-mx-auto">
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-gap-5 wb-max-w-3xl wb-mx-auto">
                {content}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-14 md:wb-gap-x-14 md:wb-gap-y-20 md:wb-grid md:wb-grid-cols-3">
                {items}
              </BlockSection.NestedBlock>
            </div>
          </BlockSection.Content>
        </BlockSection.Container>
      </BlockSection.Background>
    </BlockSection>
  );
});

BlogListingBlock1.displayName = "BlogListingBlock1";
